import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import PageShell from '@/components/site/PageShell';
import PageHero from '@/components/site/PageHero';
import TargetAudience from '@/components/site/TargetAudience';
import ClosingCTA from '@/components/site/ClosingCTA';

const COPY = {
  it: {
    eyebrow: 'A chi ci rivolgiamo',
    title_a: 'Per studi cresciuti oltre',
    title_b: 'fogli Excel, note vocali e dieci tab aperte.',
    subtitle:
      'Studio privato, clinica oculistica, centro chirurgico o rete sanitaria: realtà diverse, stesso punto di rottura. Quando i pazienti aumentano, il caos operativo è la prima cosa che ti ferma. Prime Vision è costruito esattamente per questo momento — quando hai bisogno di ordine, non di un altro tool.',
  },
  en: {
    eyebrow: 'Who it\'s for',
    title_a: 'For practices that have outgrown',
    title_b: 'Excel sheets, voice notes and ten open tabs.',
    subtitle:
      'Private practice, eye clinic, surgical center or healthcare network: different settings, same breaking point. As patients grow, operational chaos is the first thing that stops you. Prime Vision is built exactly for this moment — when you need order, not yet another tool.',
  },
};

export const TargetPage = () => {
  const { locale } = useLanguage();
  const c = COPY[locale] || COPY.it;

  return (
    <PageShell title={c.eyebrow} testId="pv-target-page">
      <PageHero
        eyebrow={c.eyebrow}
        title_a={c.title_a}
        title_b={c.title_b}
        subtitle={c.subtitle}
        ctas={['demo', 'brochure', 'whatsapp']}
        source="target-hero"
        testId="pv-target-page-hero"
      />
      <TargetAudience compact />
      <ClosingCTA source="target-closing" />
    </PageShell>
  );
};

export default TargetPage;
